import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ECMembersUploadTemplateType} from 'smag-commons/dto/api/templates';
import {FormBuilder, FormControl, FormGroup, ValidationErrors} from '@angular/forms';
import {downloadBlob, isBlank} from '../../../commons/commons';
import {SmagApiService} from '../../../api/smag-api.service';
import {MsgBoxService} from '../../../shared/msg-box.service';
import {I18NService} from '../../../i18n/i18n.service';


const MAX_FILE_MB = 2;
const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

interface Template {
    name: string;
    file: File;
}

export interface UploadData {
    file: Template;
    fileType: ECMembersUploadTemplateType;
}

@Component({
    selector: 'app-members-massive-import',
    templateUrl: './members-massive-import.component.html',
    styleUrls: ['./members-massive-import.component.scss']
})
export class MembersMassiveImportComponent implements OnInit {

    @Input() resourceId: string;
    @Output() uploadedData: EventEmitter<UploadData>;
    STEPS: string[];
    currentStep: number;
    fileUploaded: boolean;
    templateChosen: boolean;
    TEMPLATE_TYPES: { [key: string]: ECMembersUploadTemplateType };
    XLSX_MIME_TYPE: string = XLSX_MIME_TYPE;
    MAX_FILE_MB: number = MAX_FILE_MB;
    selectedUploadMode: ECMembersUploadTemplateType;
    form: FormGroup;
    template: Template;
    readonly ECMembersUploadTemplateType = ECMembersUploadTemplateType;

    constructor(private fb: FormBuilder,
                private apiService: SmagApiService,
                private readonly i18n: I18NService,
                private readonly msgBoxService: MsgBoxService) {
        this.STEPS = [
            'Statistical Profile',
            'Download Excel',
            'How to fill data',
            'Upload Excel'
        ];
        this.TEMPLATE_TYPES = {
            'Single Hour': ECMembersUploadTemplateType.MONTHLY_SINGLE_HOURLY,
            'Time Slots': ECMembersUploadTemplateType.MONTHLY_TIME_SLOTS,
        };
        this.currentStep = 1;
        this.fileUploaded = false;
        this.templateChosen = false;
        this.selectedUploadMode = null;
        this.template = {name: null, file: null};
        this.form = this.fb.group({
            radioGroup: new FormControl(null, []),
            monthlyMat: new FormControl(null, [])
        }, {
            validators: [validateForm]
        });
        this.uploadedData = new EventEmitter<UploadData>();
    }

    ngOnInit(): void {
    }


    onSelectUploadMode(ttype: ECMembersUploadTemplateType) {
        this.selectedUploadMode = ttype;
    }

    get isFirstPageValid(): boolean {
        return this.form.valid;
    }

    get isSecondPageValid(): boolean {
        return true;
    }

    get isThirdPageValid(): boolean {
        return true;
    }


    isNextEnabled(step: number) {
        switch (step) {
            case 1:
                return this.isFirstPageValid;
            case 2:
                return this.isSecondPageValid;
            case 3:
                return this.isThirdPageValid;
            default:
                return false;
        }
    }

    nextStep() {
        this.currentStep++;
    }

    prevStep() {
        this.currentStep--;
    }

    onClickDownloadTemplate() {

        this.apiService.downloadMembersTemplateExcel(this.selectedUploadMode, this.resourceId)
            .subscribe(([data, filename]) => {
                downloadBlob(data, filename);
            }, error => {
                this.msgBoxService.error(this.i18n.translate('There was an error while downloading the file'));
            });

    }

    onClickUploadTemplate($event: Event) {
        const tg = $event.target as HTMLInputElement;
        if (tg.files && tg.files.length) {
            const file: File = tg.files[0];
            if (this.validateFile(file)) {
                this.template = {name: file.name, file};
                this.templateChosen = true;
            }

        }
    }

    private validateFile(file: File): boolean {
        if (file.size > MAX_FILE_MB * 1048576) {
            this.msgBoxService.error(this.i18n.translate('Size of file {0} must be below {1} MB', file.name, MAX_FILE_MB));
            return false;
        }
        if (file.type !== XLSX_MIME_TYPE) {
            this.msgBoxService.error(this.i18n.translate('File {0} is not an XLSX file', file.name));
            return false;
        }
        return true;
    }

    onClickTrashTemplate(fileSelect: HTMLInputElement) {
        fileSelect.value = null; // allows file re-selection
        this.template = {name: null, file: null};
        this.templateChosen = false;
    }

    sendIt() {
        this.fileUploaded = true;
        this.uploadedData.next({file: this.template, fileType: this.selectedUploadMode});
    }

}

function validateForm(formGroup: FormGroup): ValidationErrors {

    const radioGropupValue = formGroup.value.radioGroup;
    const selectorValue = formGroup.value.monthlyMat;

    if (!isBlank(radioGropupValue) && radioGropupValue === 'radioStat') {
        return null;
    }

    if (!isBlank(radioGropupValue)
        && radioGropupValue === 'radioMonth'
        && !isBlank(selectorValue)) {
        return null;
    }

    return {missing_value: true};

}

